import React from "react";
import { ProtectedAdmin } from "../../components";

function AdminProtected (){
    return(
        <ProtectedAdmin />
    )
}

export default AdminProtected